export default "__VITE_ASSET__DeJ4GqAt__"